module.exports = __webpack_public_path__ + "img/2025-0424-01-02.c2d5908f.png";